import { CHOICE_FLOWS, FEATURES, readProductChoice, resolveProductChoice } from "./productChoice"

// Kept for the Recover surfaces that ask "did this merchant pick Recover?" after onboarding.
// They run on accounts with progress, so a missing answer resolves to Prevent only (OB-X-07)
// instead of the old fail-open "everything is selected". Recover chosen in either flow counts.
export const hasSelectedFeature = (key) => {
  const flows = [CHOICE_FLOWS.ONBOARDING, CHOICE_FLOWS.BUSINESS]

  if (key === FEATURES.PREVENT) {
    return flows.some((flow) => resolveProductChoice({ flow, hasProgress: true }).includes(key))
  }

  return flows.some((flow) => (readProductChoice(flow) ?? []).includes(key))
}
